<section class="d-flex gap5">
    <button class="btn" (click)="ontimeSplit('hour')" [ngClass]="{'time-split': timeSplit?.hour}">h</button>
    <button class="btn" (click)="ontimeSplit('min')" [ngClass]="{'time-split': timeSplit?.min}">m</button>
    <button class="btn" (click)="ontimeSplit('sec')" [ngClass]="{'time-split': timeSplit?.sec}">s</button>
</section>